<template>
  <div class="my-order" >
    <div class="my-order-filter">
      <h4 class="my-order-filter-title">购买记录</h4>
      <div type="flex" class="my-order-filter-field">
        <div :span="6" class="field-item">
          <div class="field-item-label">下单时间</div>
          <div class="field-item-value">
            <el-date-picker
              class="field-item-datepicker"
              v-model="dateValue"
              type="daterange"
              @change="dateChange"
              range-separator="—"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy-MM-dd"
              value-format="timestamp"
              :default-time="['00:00:00', '23:59:59']"
              style="width: 220px;"
            ></el-date-picker>
          </div>
        </div>
        <div class="field-item">
          <div class="field-item-label">订单状态</div>
          <div class="field-item-value">
            <el-select
              v-model="orderStatus"
              style="width: 200px;"
              clearable
            >
              <el-option  
                v-for="(i,index) in searchForm"
                :key="index"  
                :label="i.name" 
                :value="i.codeValue"
              ></el-option>
              
            </el-select>
          </div>
        </div>
        <div class="field-item">
          <el-button class="field-item-btn" type="primary" @click="search">查询</el-button>
          <el-button class="field-item-btn" plain @click="reset">重置</el-button>
        </div>
      </div>
    </div>

    <div class="my-order-content-nodata" v-if="this.tableData.length===0">
      <img src="@/assets/image/common/noData.png" alt="" style="width: 322px;height: 99px;margin-bottom:10px;">
      <p>暂无数据…</p> 
    </div>
    <div class="my-order-content" v-else>
      <ul class="my-order-list"  v-loading="loading">
        <li v-for="(data,index) in tableData" :key="index" class="my-order-item">
          <div class="order-item-overview">
            <ul class="overview-l">
              <li class="overview-l-item item-title" v-if="data.trial ==0">智工嗨搜基础版&资源包(组合)</li>
              <li class="overview-l-item item-title" v-else>智工嗨搜基础版</li>
              <li class="overview-l-item item-money">
                <span class="item-label">优惠金额:</span>
                <span class="item-value">{{data.discountAmount | formatMoney}}元</span>

                <el-tooltip effect="dark" placement="bottom-start" v-if="data.discountAmount > 0 && data.remark">
                  <div slot="content" style="line-height:20px;width:191px;">{{data.remark}}</div>
                  <i class="iconfont icon-icon-xinxi " style="margin-left:3px;color:#98A3B7;font-size:14px;"></i>
                </el-tooltip>
              </li>
              <li class="overview-l-item item-money">
                <span class="item-label">订单金额:</span>
                <span class="item-value">{{data.payAmount | formatMoney}}元</span>
              </li>
              <li class="overview-l-item item-other">
                <span class="item-label">订单号:</span>
                <span class="item-value">{{data.orderNo}}</span>
              </li>
              <li class="overview-l-item item-other">
                <span class="item-label">合同编号:</span>
                <span class="item-value">{{data.contractNo || '---'}}</span>
              </li>
              <li class="overview-l-item item-other">
                <span class="item-label">下单时间:</span>
                <span class="item-value">{{ handleFormatDateAndTime(data.createTime) }}</span>
              </li>
            </ul>
            <div class="overview-r">
              <!-- 订单状态 -->
              <OrderStatus 
                :key="data.orderNo"
                :status='data.status' 
                :statusShow="data.statusShow"
                :signingStatus="data.signingStatus"
                :trial='data.trial'
                :payRemainingTime='data.payRemainingTime'
                :expireTime="data.expireTime"
              />
            </div>
          </div>
          <div class="order-item-detail">
            <!-- 订单明细 -->
            <OrderDetail 
              ref="orderDetail"
              :orderStatus="orderStatus"
              :startDate ="timeForm.startDate"
              :endDate ="timeForm.endDate"
              :subscribeList="data.subscribeList" 
              :signingStatus="data.signingStatus"
              :status='data.status' 
              :trial='data.trial'
              :orderNo='data.orderNo'
              :paymentStatus='data.paymentStatus'
              :payAmount='data.payAmount'
              :paymentStatusShow='data.paymentStatusShow'
              :receipt ='data.receipt'
              :contractHashcode ='data.contractHashcode'
              @getOrderTableList="getOrderTableList"
              @sendVisible='sendVisible'
              @getOrder='getOrder'

            />
            <!-- <div class="order-item-detail-desc">
              <span class="detail-desc-label">订单说明:</span>
              <span class="detail-desc-value">海智铂海智铂金会员，钻石会员，VIP会员海智铂金会员，钻石会员，VIP会员海智铂金会员，钻石会员，VIP会员海智铂金会员，钻石会员，VIP会员金会员，钻石会员，VIP会员海智铂金会员，钻石会员，VIP会员，VVIP会员限时特惠</span>
            </div> -->
          </div>
        </li>
      </ul>
    </div>
    <!-- 分页器 -->
    <div style="text-align: center; margin-top: 20px; margin-bottom:20px" >
      <el-pagination
        background
        layout="prev, pager, next"
        :total="totalNum"
        :page-size="10"
        :currentPage.sync="currentPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import OrderStatus from '@/components/cost-center/order-status'
import OrderDetail from '@/components/cost-center/order-detail'
import {getOrderList,getSingleDictByType} from '@/utils/api/order'
import CorporatePayment from '@/components/cost-center/CorporatePayment.vue'
export default {
  data() {
    return {
      loading: true,
      tableData:[],
      subscribeList:[],
      searchForm: [],
      timeForm: [],
      orderStatus: null,
      dateValue: '',
      currentPage: 1,
      totalNum:0,
      getOrderNo:'',
      getMoney:'',
      params:{},
    }
  },
  components: {
    OrderStatus,
    OrderDetail,
    CorporatePayment,
  },
  methods: {
    getOrder(val,money){
      this.getOrderNo = val
      this.getMoney = money
    },
    sendVisible(val){
      if(this.getOrderNo){
        this.$refs.CorporatePayment.visible = val;
      }
    },
    handleFormatDateAndTime(value) {
      if (value) {
        return moment(value).format('YYYY-MM-DD HH:mm:ss')
      }
      return '--'
    },
    dateChange(value) {
      if(value && value.length) {
        this.timeForm.startDate = value[0] || '';
        this.timeForm.endDate = value[1] || '';
      }else {
        this.timeForm.startDate = '';
        this.timeForm.endDate = '';
      }
    },
    // 获取订单列表
    getOrderTableList(orderStatus,startDate,endDate, callback = () => {}){
      const params = {
        curPage: this.currentPage,
        pageSize: 10,
        attribute: "",
        sortType: 0,
        startTime: startDate? startDate :'',
        endTime: endDate ? endDate :'',
        orderStatus: orderStatus ? orderStatus : null
      }
      getOrderList(params)
      .then(res=>{
        if(res.rspResult.bizCode==200){
          this.tableData = res.rspPageData.list || [];
          this.totalNum = res.rspPageData.totalNum;
        }
        callback()
        this.loading = false;
        

      })
      .catch(err=>{
        callback()
        this.loading = false;
        console.log('获取列表失败',err);
      })
    },
    // 获取订单状态
    async initData() {
      try {
        const res = await getSingleDictByType(
          'saas_order_status'
        )
        if (res.rspResult.bizCode === 200) {
          this.searchForm = res.rspListData.list
        }
      } catch (err) {
        console.error("❌ ~ file: my-order.vue:363 ~ initData ~ err:", err)
      }
    },
    search(){
      this.currentPage= 1,
      this.getOrderTableList(this.orderStatus,this.timeForm.startDate,this.timeForm.endDate )
      // 保存上次搜索条件
      this.params = {
        oldStatus:this.orderStatus,
        oldStartDate:this.timeForm.startDate,
        oldEndDate:this.timeForm.endDate
      }
    },
    reset(){
      this.currentPage= 1,
      this.orderStatus=null;
      this.dateValue= '',
      this.timeForm.startDate = '';
      this.timeForm.endDate = '';
      this.params = {
        oldStatus:this.orderStatus,
        oldStartDate:this.timeForm.startDate,
        oldEndDate:this.timeForm.endDate
      }
      this.getOrderTableList()
    },
    // 切换页数
    handleCurrentChange(val){
      this.currentPage = val;
      if(this.params.oldStatus && !this.params.oldStartDate){
        this.dateValue= ''
        this.orderStatus = this.params.oldStatus
        this.timeForm.startDate = '';
        this.timeForm.endDate = ''
        // console.log('走到这啦111111~~');

        this.getOrderTableList(this.params.oldStatus,this.params.oldStartDate,this.params.oldEndDate)
      }else if(!this.params.oldStatus && this.params.oldStartDate){
        // console.log('走到这啦2222~~');
        this.orderStatus='';
        this.dateValue= [this.params.oldStartDate,this.params.oldEndDate],
        this.getOrderTableList(this.params.oldStatus,this.params.oldStartDate,this.params.oldEndDate)
      }else if(this.params.oldStatus && this.params.oldStartDate){
        // console.log('走到这啦3333~~');
        this.orderStatus=this.params.oldStatus;
        this.dateValue= [this.params.oldStartDate,this.params.oldEndDate],
        this.getOrderTableList(this.params.oldStatus,this.params.oldStartDate,this.params.oldEndDate)
      }else{
        this.orderStatus='';
        this.dateValue= '',
        this.timeForm.startDate = '';
        this.timeForm.endDate = '';
        this.getOrderTableList()
        // console.log('走到这啦4444~~');
      }

      const listEle= document.querySelector('.el-scrollbar-wrap');
      listEle.scrollTop = 0;
    },
    
  },
  
  mounted(){
    this.getOrderTableList()
    this.initData()
  },
}
</script>

<style lang="scss" scoped>
.my-order {
  &-filter {
    background: #fff;
    padding: 20px;
    margin-bottom: 5px;
    &-title {
      width: max-content;
      height: 15px;
      line-height: 15px;
      font-family: SourceHanSansCN-Medium;
      font-weight: 500;
      font-size: 14px;
      color: #16181A;
      letter-spacing: 0;
      margin-bottom: 20px;
    }
    &-field {
      min-height: 32px;
      line-height: 32px;
      font-family: SourceHanSansCN-Regular;
      font-size: 12px;
      color: #16181A;
      letter-spacing: 0;
      display: flex;
      align-items: flex-end;
      .field-item {
        display: flex;
        &-label {
          margin-right: 16px;
        }
        &:nth-child(1) {
          margin-right: 32px;
        }
        &:nth-last-child(1) {
          margin-left: auto;
        }
        ::v-deep .field-item-btn {
          width: 64px;
          border-radius: 4px;
          span {
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            color: #4F5D78;
          }
          &:nth-child(1) {
            span {
              color: #fff;
            }
          }
        }
        ::v-deep .field-item-btn:focus{
          &:nth-child(1) {
            border-color: #066EB7 !important;
            color: #FFFFFF !important;
            background-color: #066EB7 !important;
          }
          &:nth-child(2) {
            border-color: #DCDFE6;
          }
        }
        ::v-deep .field-item-btn:nth-child(1):hover{
            border-color: #308eec !important;
            color: #FFFFFF !important;
            background-color: #308eec !important;
        }
        ::v-deep .field-item-btn:nth-child(2):hover{
            border-color: #066EB7 !important;
        }
        ::v-deep .field-item-datepicker {
          .el-range-input {
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 12px;
            letter-spacing: 0;
            &::placeholder {
              color: #98A3B7;
            }
          }
        }
      }
    }
  }
  &-content-nodata{
    background: #fff;
    padding: 20px;
    color: #4F5D78;
    font-family: SourceHanSansCN-Regular;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
  }
  &-content {
    background: #fff;
    padding: 20px;
    .my-order-list {
      .my-order-item {
        margin-bottom: 20px;
        .order-item-overview {
          display: flex;
          background: #F5F7FA;
          .overview-l {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            padding: 18px 0 4px 18px;
            &-item {
              width: calc(100% / 3);
              font-family: SourceHanSansCN-Medium;
              font-size: 14px;
              height: 18px;
              line-height: 18px;
              margin-bottom: 11px;
              color: #16181A;
              &.item-title {
                font-family: SourceHanSansCN-Medium;
                font-weight: 500;
                font-size: 14px;
                color: #4F5D78;
              }
              .item-label {
                color: #4F5D78;
                margin-right: 3px;
              }
              &-money {
                
              }
              &.item-other {
                font-size: 12px;
              }
            }
          }
          .overview-r {
            width: 240px;
            border-left: 1px solid #fff;
            flex-shrink: 0;
            
          }
        }
        .order-item-detail {
          &-desc {
            padding: 14px 21px;
            border: 1px solid #EDF0F4;
            border-top: 0;
            display: flex;
            line-height: 16px;
            font-family: SourceHanSansCN-Regular;
            font-weight: 400;
            font-size: 12px;
            color: #16181A;
            letter-spacing: 0;
            word-break: break-word;
            .detail-desc-label {
              color: #4F5D78;
              margin-right: 8px;
              width: max-content;
              flex-shrink: 0;
            }
          }
        }

        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
  }
}

::v-deep.el-table th.el-table__cell {
  color: #16181A !important;
  padding-left: 10px;
}
::v-deep.el-table td.el-table__cell {
  color: #4F5D78 !important;
  font-family: SourceHanSansCN-Regular;
  font-weight: 400;
  font-size: 12px;
  padding-left: 10px;
}

</style>
<style lang="scss">
.el-tooltip__popper.is-dark{
  width: 240px;
}
</style>